import React, { useEffect } from 'react';
import { MapContainer, Marker, Popup, TileLayer, useMap } from 'react-leaflet';
import L from 'leaflet';
import MAP_CONFIG from '../../../config/mapConfig';

const technicianPinIcon = L.divIcon({
  className: 'sa-tech-pin',
  html: '<span class="sa-tech-pin__pulse"></span><span class="sa-tech-pin__dot"></span>',
  iconSize: [22, 22],
  iconAnchor: [11, 11],
  popupAnchor: [0, -12],
});

function FitBounds({ points }) {
  const map = useMap();

  useEffect(() => {
    if (!points || points.length === 0) {
      map.setView(MAP_CONFIG.defaultCenter, MAP_CONFIG.defaultZoom);
      return;
    }

    if (points.length === 1) {
      map.setView(points[0], 11);
      return;
    }

    const bounds = L.latLngBounds(points);
    map.fitBounds(bounds, { padding: [35, 35], maxZoom: 12 });
  }, [map, points]);

  return null;
}

export default function LeafletTechnicianMap({ technicians = [], onSelectTechnician }) {
  const points = technicians
    .filter((t) => {
      const lat = Number(t.displayLatitude ?? t.latitude);
      const lng = Number(t.displayLongitude ?? t.longitude);
      return Number.isFinite(lat) && Number.isFinite(lng);
    })
    .map((t) => [
      Number(t.displayLatitude ?? t.latitude),
      Number(t.displayLongitude ?? t.longitude),
    ]);

  return (
    <MapContainer
      center={MAP_CONFIG.defaultCenter}
      zoom={MAP_CONFIG.defaultZoom}
      scrollWheelZoom
      className="sa-map"
      minZoom={MAP_CONFIG.minZoom}
      maxZoom={MAP_CONFIG.maxZoom}
    >
      <TileLayer attribution={MAP_CONFIG.tileAttribution} url={MAP_CONFIG.tileUrl} />
      <FitBounds points={points} />

      {technicians.map((tech) => {
        const lat = Number(tech.displayLatitude ?? tech.latitude);
        const lng = Number(tech.displayLongitude ?? tech.longitude);
        if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;

        return (
          <Marker
            key={tech.id}
            position={[lat, lng]}
            icon={technicianPinIcon}
            eventHandlers={{
              click: () => {
                if (onSelectTechnician) onSelectTechnician(tech);
              },
            }}
          >
            <Popup>
              <div className="sa-map-popup">
                <strong>{tech.full_name}</strong>
                <div>{tech.city}, {tech.province}</div>
                <div>{tech.tech_type === 'other' ? (tech.custom_tech_type || 'Other') : tech.tech_type}</div>
              </div>
            </Popup>
          </Marker>
        );
      })}
    </MapContainer>
  );
}
